import { connect } from 'react-redux';
import { get } from 'lodash';

import RolesSwitcher from './RolesSwitcher';
import { handleRoleSwitch } from '../../../../screens/Login/actions';

const mapStateToProps = (state) => ({
  currentRoles: get(state, 'login.user.currentRoles', []),
  isSwitchingRoles: get(state, 'login.isSwitchingRoles'),
  switchingRolesError: get(state, 'login.switchingRolesError'),
});

const mapDispatchToProps = (dispatch) => ({
  handleRoleSwitch: (selectedRoles) => dispatch(handleRoleSwitch(selectedRoles)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RolesSwitcher);
